﻿﻿export interface IGpsAutomation {
    id: number;
    gpsNumber: number;
    gpsLink: string;
    trackingNumber: string;
    gpsStatus: number;
    gpsComments: string;
    statusDate: string;
    imei: string;
}
